/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from 'vue-router/auto'
import { setupLayouts } from 'virtual:generated-layouts'
import { routes } from 'vue-router/auto-routes'
import { useAppStore } from '../stores/app';
import { protectedRoutes } from './protectedRoutes';
import axios from 'axios';
//import { addLoader} from '../loader';

axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL+import.meta.env.VITE_API_VER.replaceAll('.', '_');



const additionalRoutes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/visit',
    component: () => import('@/pages/visit/index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/pages/logout.vue')
  },
  {
    path: '/visit/add',
    name: 'AddVisit',
    component: () => import('@/pages/visit/add.vue')
  },
  {
    path: '/visit/change',
    name: 'EditVisit',
    component: () => import('@/pages/visit/change.vue')
  },
  {
    path: '/visit/id:IDstring',
    name: 'SingleVisit',
    component: () => import('@/pages/visit/single.vue')
  },
  {
    path: '/balance',
    name: 'Balance',
    component: () => import('@/pages/balance.vue')
  },
  {
    path: '/workinghours',
    name: 'WorkingHours',
    component: () => import('@/pages/workinghours.vue')
  },
  {
    path: '/survey/first',
    name: 'SurveyF',
    component: () => import('@/layouts/frontpage.vue'), 
    children: [
      { path: '', component: () => import('@/pages/survey/first.vue') }
    ], 
  },
  {
    path: '/survey/second',
    name: 'SurveyS',
    component: () => import('@/layouts/frontpage.vue'), 
    children: [
      { path: '', component: () => import('@/pages/survey/second.vue') }
    ], 
  },
  {
    path: '/survey/third',
    name: 'SurveyT',
    component: () => import('@/layouts/frontpage.vue'), 
    children: [
      { path: '', component: () => import('@/pages/survey/third.vue') }
    ], 
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  //routes: setupLayouts([...routes, ...additionalRoutes]),
  routes: setupLayouts([...additionalRoutes]),
})

router.beforeEach(async (to, from, next) => {
  if (!window.Loader.loaderActive) window.Loader.addLoader('Change route...');
  const appStore = useAppStore();
  let User = localStorage.getItem('User') ? JSON.parse(localStorage.getItem('User')) : false;
  if (User) {
    appStore.addRouteLog({to: to.path, from: from.path, next: next.path});
  }
  const needsAuth = protectedRoutes.some(prefix => to.path.startsWith(prefix));

  const tgAuth = to.query.tg_auth;
  const tgId = to.query.tg_id;
  if (tgAuth && tgId) {
    localStorage.removeItem('DefaultView');
    localStorage.removeItem('User');
    console.log('remove User');
    axios.post('/auth/login/external', { secret_login_token: tgAuth, login: tgId })
      .then(response => {
        console.log('get auth tokens');
        localStorage.setItem('accessToken', response.data.access_token);
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }).then(() => {
        console.log('get User');
        appStore.getUser();
      }).then(()=>{
        console.log('next url',to.path);
        next();
      })
      .catch(error => {
        console.error(error);
        next(false); // Остановка перехода при ошибке
      });
  }
  else if (needsAuth) {
    await appStore.getUser();
    await appStore.setTryToURL(to.path);
    //next({ path: '/login' });  // Перенаправление на страницу входа
    await next();
  } else {
    console.log('try to next ',to, next )
    next();  // Продолжение маршрута
  }
});

router.afterEach(() => {

})

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (!localStorage.getItem('vuetify:dynamic-reload')) {
      console.log('Reloading page to fix dynamic import error')
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    } else {
      console.error('Dynamic import error, reloading page did not fix it', err)
    }
  } else {
    console.error(err)
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

export default router
